import React, { Fragment } from "react";
import YellowConfirm from "./YellowConfirm";
import Button from "./Button";
import searchDown from "../img/searchArrow/Vector.png";
import searchUp from "../img/searchArrow/Vector (1).png";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import { addMessaggio } from "../reducers/apartments";
import { connect } from "react-redux";
import moment from "moment";
import { printChat } from "../services/createPdf";

let textSearch = React.createRef();

const styleInputBox = {
  borderStyle: "solid",
  marginTop: "0vh",
  marginBottom: "0vh",
  height: "3vh",
  width: "76vw",
  paddingLeft: 16,
  outline: 0,
  borderTopLeftRadius: 16,
  borderBottomLeftRadius: 16,
  borderWidth: 1,
};

const textAllert = [
  {
    text: "Attenzione",
    fontSize: 32,
    paddingBottom: "3vh",
  },
  {
    text: "Confermi?",
    fontSize: 18,
    paddingBottom: "3vh",
  },
];

const chat = [
  {
    from: "admin",
    text:
      "sono un riempitivo, ma a dxsono un riempitivo, ma a dxsono un riempitivo, ma a dxsono un riempitivo, ma a dxsono un riempitivo, ma a dxsono un riempitivo, ma a dxsono un riempitivo, ma a dxsono un riempitivo, ma a dxsono un riempitivo, ma a dxsono un riempitivo, ma a dxsono un riempitivo, ma a dxsono un riempitivo, ma a dxsono un riempitivo, ma a dxsono un riempitivo, ma a dxsono un riempitivo, ma a dxsono un riempitivo, ma a dxsono un riempitivo, ma a dxsono un riempitivo, ma a dxsono un riempitivo, ma a dxsono un riempitivo, ma a dx",
  },
  {
    from: "user",
    text:
      "sono un riempitivo ma a sx, sono un riempitivo ma a sx, sono un riempitivo ma a sx, sono un riempitivo ma a sx, sono un riempitivo ma a sx, sono un riempitivo ma a sx, sono un riempitivo ma a sx, sono un riempitivo ma a sx, sono un riempitivo ma a sx, sono un riempitivo ma a sx, sono un riempitivo ma a sx, sono un riempitivo ma a sx, sono un riempitivo ma a sx, ",
  },
  {
    from: "admin",
    text:
      "sono un riempitivo, ma a dxsono un riempitivo, ma a dxsono un riempitivo, ma a dxsono un riempitivo, ma a dxsono un riempitivo, ma a dxsono un riempitivo, ma a dxsono un riempitivo, ma a dxsono un riempitivo, ma a dxsono un riempitivo, ma a dxsono un riempitivo, ma a dxsono un riempitivo, ma a dxsono un riempitivo, ma a dxsono un riempitivo, ma a dxsono un riempitivo, ma a dxsono un riempitivo, ma a dxsono un riempitivo, ma a dxsono un riempitivo, ma a dxsono un riempitivo, ma a dxsono un riempitivo, ma a dxsono un riempitivo, ma a dx",
  },
  {
    from: "user",
    text:
      "sono un riempitivo ma a sx, sono un riempitivo ma a sx, sono un riempitivo ma a sx, sono un riempitivo ma a sx, sono un riempitivo ma a sx, sono un riempitivo ma a sx, sono un riempitivo ma a sx, sono un riempitivo ma a sx, sono un riempitivo ma a sx, sono un riempitivo ma a sx, sono un riempitivo ma a sx, sono un riempitivo ma a sx, sono un riempitivo ma a sx, ",
  },
  {
    from: "user",
    text:
      "sono un riempitivo ma a sx, sono un riempitivo ma a sx, sono un riempitivo ma a sx, sono un riempitivo ma a sx, sono un riempitivo ma a sx, sono un riempitivo ma a sx, sono un riempitivo ma a sx, sono un riempitivo ma a sx, sono un riempitivo ma a sx, sono un riempitivo ma a sx, sono un riempitivo ma a sx, sono un riempitivo ma a sx, sono un riempitivo ma a sx, ",
  },
  {
    from: "admin",
    text:
      "sono un riempitivo, ma a dxsono un riempitivo, ma a dxsono un riempitivo, ma a dxsono un riempitivo, ma a dxsono un riempitivo, ma a dxsono un riempitivo, ma a dxsono un riempitivo, ma a dxsono un riempitivo, ma a dxsono un riempitivo, ma a dxsono un riempitivo, ma a dxsono un riempitivo, ma a dxsono un riempitivo, ma a dxsono un riempitivo, ma a dxsono un riempitivo, ma a dxsono un riempitivo, ma a dxsono un riempitivo, ma a dxsono un riempitivo, ma a dxsono un riempitivo, ma a dxsono un riempitivo, ma a dxsono un riempitivo, ma a dx",
  },
  {
    from: "user",
    text:
      "sono un riempitivo ma a sx, sono un riempitivo ma a sx, sono un riempitivo ma a sx, sono un riempitivo ma a sx, sono un riempitivo ma a sx, sono un riempitivo ma a sx, sono un riempitivo ma a sx, sono un riempitivo ma a sx, sono un riempitivo ma a sx, sono un riempitivo ma a sx, sono un riempitivo ma a sx, sono un riempitivo ma a sx, sono un riempitivo ma a sx, ",
  },
];

const lightYellow = "#FFEF85";

const styleArrow = {
  height: 13,
  width: 25,
  objectFit: "fill",
  marginRight: 8,
  cursor: "pointer",
};

let input = React.createRef();
class Chat extends React.Component {
  state = {
    searching: false,
    openStampa1: false,
    openStampa2: false,
    openStampa3: false,
    filter: "",
    printFrom: moment().subtract(1, "week").format("YYYY-MM-DD"),
    printTo: moment().format("YYYY-MM-DD"),
  };

  componentDidMount() {
    this.scrollToBottom();
  }

  componentDidUpdate() {
    this.scrollToBottom();
  }

  confirm1 = () => {
    this.setState({ openStampa2: !this.state.openStampa2, openStampa1: !this.state.openStampa1 });
  };

  goBack1 = () => {
    this.setState({ openStampa2: !this.state.openStampa2 });
    this.setState({ openStampa1: !this.state.openStampa1 });
  };

  formatDate = (date) => moment(date).format("YYYY/MM/DD");

  confirm2 = () => {
    // printer
    console.log("called");
    const messages = this.props.apartment.user.messaggi.filter(
      (msg) =>
        this.formatDate(msg.createdAt) >= this.formatDate(this.state.printFrom) &&
        this.formatDate(msg.createdAt) <= this.formatDate(this.state.printTo)
    );
    if (messages.length > 0) {
      console.log("ci son messaggi");
      printChat(messages, this.props.apartment.name);
    }

    this.setState({ openStampa2: !this.state.openStampa2, openStampa3: !this.state.openStampa3 });
    setTimeout(() => {
      this.setState({ openStampa3: !this.state.openStampa3 });
    }, 1200);
  };

  scrollToBottom = () => {
    this.messagesEnd && this.messagesEnd.scrollIntoView({});
  };

  search = (e) => {
    const value = e.target.value;
    const searched = this.props.apartment.user.messaggi.filter((todo) => {
      return todo.text.toLowerCase().includes(value);
    });
  };

  inviaMessaggio = () => {
    this.props.addMessaggio(input.current.value);
    input.current.value = "";
    this.scrollToBottom();
  };

  getMessageTime = (messageTime) => {
    let date = new Date(messageTime);
    var currentMinutes = date.getMinutes();
    currentMinutes = ("0" + currentMinutes).slice(-2);
    var currentDay = date.getDay();
    currentDay = ("0" + currentDay).slice(-2);
    var currentMonth = date.getMonth();
    currentMonth = ("0" + currentMonth).slice(-2);

    return (
      <div>
        {/* {date.getHours()}:{currentMinutes} - {currentDay}/{currentMonth}/{date.getFullYear()} */}
        {date.getHours()}:{currentMinutes}
      </div>
    );
  };

  handlePrint = () => {
    this.setState({ openStampa1: !this.state.openStampa1 });
  };

  handleChangeDate = (e, target) => {
    this.setState({ [target]: e.target.value });
  };

  search = (e) => {
    this.setState({ filter: e.target.value });
  };

  render() {
    const arraymessaggi = this.props.apartment.user.messaggi;
    // console.log('apt', this.props.apartment)
    // console.log(addChangeDate(arraymessaggi));
    return (
      <Fragment>
        <div style={{ display: "flex", flexDirection: "column", padding: "2.6vh" }}>
          <div
            style={{
              display: "flex",
              justifyContent: !this.state.searching ? "flex-end" : "space-between",
              paddingBottom: "2vh",
            }}
          >
            <YellowConfirm
              text={"Stampa"}
              // action={() => this.setState({ openStampa1: !this.state.openStampa1 })}
              action={this.handlePrint}
              padding={"0.6vh"}
              width={"10vw"}
            />
            {!this.state.searching ? (
              <div style={{ marginLeft: "6vw" }}>
                <Button
                  {...this.props}
                  scope={"search"}
                  goTo={() => this.setState({ searching: !this.state.searching })}
                />
              </div>
            ) : (
              <div>
                <input
                  ref={textSearch}
                  onChange={this.search}
                  type="text"
                  style={{
                    border: "1px solid #645B40",
                    height: "3vh",
                    width: "24vw",
                    paddingLeft: 16,
                    borderRadius: 8,
                    backgroundColor: "#FFEF85",
                  }}
                  placeholder={"Inserisci qui il testo da cercare"}
                />
                {/* <img src={searchUp} alt="" style={styleArrow} />
                <img src={searchDown} alt="" style={styleArrow} /> */}
              </div>
            )}
          </div>

          <div
            className={"hideScrollBar"}
            style={{
              backgroundColor: "#645B40",
              height: window.innerHeight * 0.56,
              display: "flex",
              flexDirection: "column",
              overflowY: "scroll",
            }}
          >
            {addChangeDate(arraymessaggi)
              .filter((msg) => msg.text.toLowerCase().includes(this.state.filter.toLowerCase()))
              .map((message) => (
                <div>
                  {message.data && (
                    <div
                      style={{
                        color: "rgb(255, 239, 133)",
                        textAlign: "center",
                        fontWeight: "bold",
                        padding: "16px 0",
                      }}
                    >
                      {message.data}
                    </div>
                  )}
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: message.from == "admin" ? "flex-end" : "flex-start",
                    }}
                  >
                    <div
                      style={{
                        backgroundColor: lightYellow,
                        borderRadius: 16,
                        padding: "12px 16px",
                        margin: "6px 6px 2px 6px",
                        maxWidth: "46%",
                        fontSize: 20,
                        borderTopLeftRadius: message.from == "admin" ? 16 : 0,
                        borderTopRightRadius: message.from == "admin" ? 0 : 16,
                        wordWrap: "break-word",
                        textAlign:message.from == "admin" ? "right" : "left"
                        // textAlign: "right",
                      }}
                    >
                      {message.text}
                      <div
                        style={{
                          // textAlign: message.from == "admin" ? "right" : "left",
                          fontSize: 12,
                          paddingTop: 8,
                        }}
                      >
                        {this.getMessageTime(message.createdAt)}
                      </div>
                    </div>
                  </div>
                  <div
                    ref={(el) => {
                      this.messagesEnd = el;
                    }}
                  ></div>
                </div>
              ))}
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "1.8vh",
              marginBottom: "1vh",
            }}
          >
            <input
              type="text"
              style={styleInputBox}
              placeholder={"Inserisci qui il tuo messaggio"}
              ref={input}
            />
            <YellowConfirm
              text={"Invia"}
              action={this.inviaMessaggio}
              // padding={"0.0vh"}
              width={"8vw"}
              allBorder
            />
          </div>
        </div>
        <TransitionGroup>
          <CSSTransition
            classNames={"fade"}
            key={Math.random()}
            timeout={{ enter: 500, exit: 500 }}
            in={this.state.inProp}
            unmountOnExit={true}
          >
            {this.state.openStampa1 ? (
              <div
                style={{
                  position: "fixed",
                  top: 0,
                  left: 0,
                  height: window.innerHeight,
                  width: window.innerWidth,
                  backgroundColor: "rgba(0,0,0,0.6)",
                  zIndex: 100,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
                // onClick={() =>
                // this.setState({ openStampa1: !this.state.openStampa1 })
                // }
              >
                <div
                  style={{
                    backgroundColor: "white",
                    width: "40vw",
                    height: "40vh",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    textAlign: "center",
                    zIndex: 200,
                  }}
                >
                  <div style={{ fontSize: 32, paddingBottom: "1.8vh" }}>Attenzione</div>

                  <div
                    style={{
                      fontSize: 20,
                      paddingBottom: "0.6vh",
                      textAlign: "left",
                      width: "60%",
                    }}
                  >
                    Data di inizio di stampa?
                  </div>
                  <input
                    value={this.state.printFrom}
                    type="date"
                    onChange={(e) => this.handleChangeDate(e, "printFrom")}
                    style={{ width: "60%" }}
                  />
                  <div
                    style={{
                      fontSize: 20,
                      paddingBottom: "0.6vh",
                      textAlign: "left",
                      width: "60%",
                    }}
                  >
                    Data di fine?
                  </div>
                  <input
                    value={this.state.printTo}
                    type="date"
                    onChange={(e) => this.handleChangeDate(e, "printTo")}
                    style={{ width: "60%", marginBottom: "1.4vh" }}
                  />
                  <YellowConfirm
                    text={"Conferma"}
                    action={this.confirm1}
                    padding={"1.5vh"}
                    width={"8vw"}
                  />
                </div>
              </div>
            ) : (
              <div style={{ display: "none" }}>hidden</div>
            )}
          </CSSTransition>
        </TransitionGroup>
        <TransitionGroup>
          <CSSTransition
            classNames={"fade"}
            key={Math.random()}
            timeout={{ enter: 500, exit: 500 }}
            in={this.state.inProp}
            unmountOnExit={true}
          >
            {this.state.openStampa2 ? (
              <div
                style={{
                  position: "fixed",
                  top: 0,
                  left: 0,
                  height: window.innerHeight,
                  width: window.innerWidth,
                  backgroundColor: "rgba(0,0,0,0.6)",
                  zIndex: 100,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
                // onClick={() =>
                // this.setState({ openStampa1: !this.state.openStampa1 })
                // }
              >
                <div
                  style={{
                    backgroundColor: "white",
                    width: "40vw",
                    height: "40vh",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    textAlign: "center",
                    zIndex: 200,
                  }}
                >
                  <div style={{ fontSize: 32, paddingBottom: "1.8vh" }}>Attenzione</div>

                  <div
                    style={{
                      fontSize: 20,
                      paddingBottom: "0.6vh",
                      textAlign: "center",
                      width: "80%",
                    }}
                  >
                    Vuoi stampare tutti i messaggi da data {this.state.printFrom} a{" "}
                    {this.state.printTo}
                  </div>
                  <div style={{ display: "flex", paddingTop: "2.6vh" }}>
                    <YellowConfirm
                      text={"Indietro"}
                      action={this.goBack1}
                      padding={"1.5vh"}
                      width={"8vw"}
                    />
                    <div style={{ paddingLeft: "1.6vw" }}>
                      <YellowConfirm
                        text={"Conferma"}
                        action={this.confirm2}
                        padding={"1.5vh"}
                        width={"8vw"}
                      />
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <div style={{ display: "none" }}>hidden</div>
            )}
          </CSSTransition>
        </TransitionGroup>
        <TransitionGroup>
          <CSSTransition
            classNames={"fade"}
            key={Math.random()}
            timeout={{ enter: 500, exit: 500 }}
            in={this.state.inProp}
            unmountOnExit={true}
          >
            {this.state.openStampa3 ? (
              <div
                style={{
                  position: "fixed",
                  top: 0,
                  left: 0,
                  height: window.innerHeight,
                  width: window.innerWidth,
                  backgroundColor: "rgba(0,0,0,0.6)",
                  zIndex: 100,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
                onClick={() => this.setState({ openStampa1: !this.state.openStampa1 })}
              >
                <div
                  style={{
                    backgroundColor: "white",
                    width: "40vw",
                    height: "40vh",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    textAlign: "center",
                    zIndex: 200,
                  }}
                >
                  <div style={{ color: "#645B40", fontSize: 36 }}>Operazione Completata</div>
                </div>
              </div>
            ) : (
              <div style={{ display: "none" }}>hidden</div>
            )}
          </CSSTransition>
        </TransitionGroup>
      </Fragment>
    );
  }
}
const mapStateToProps = (state) => ({
  apartments: state.apartments.data,
  apartment: state.apartments.singleApartment,
  loading: state.apartments.loading,
  error: state.apartments.error,
});

const mapDispatchToProps = (dispatch) => {
  return {
    addMessaggio: (apartmentName, data, value) =>
      dispatch(addMessaggio(apartmentName, data, value)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Chat);

const addChangeDate = (messages) => {
  return messages.map((message, i) => {
    if (!!messages[i - 1]) {
      if (new Date(message.createdAt).getDate() !== new Date(messages[i - 1].createdAt).getDate()) {
        return {
          ...message,
          data:
            days[new Date(message.createdAt).getDay()] +
            " " +
            addZero(new Date(message.createdAt).getDate()) +
            " " +
            months[new Date(message.createdAt).getMonth()],
        };
      }
    }
    if (i === 0) {
      return {
        ...message,
        data:
          days[new Date(message.createdAt).getDay()] +
          " " +
          addZero(new Date(message.createdAt).getDate()) +
          " " +
          months[new Date(message.createdAt).getMonth()],
      };
    }
    return message;
  });
};

const addZero = (date) => {
  const str = String(date);
  if (str.length < 2) {
    return "0" + date;
  }
  return date;
};

const months = [
  "Gennaio",
  "Febbraio",
  "Marzo",
  "Aprile",
  "Maggio",
  "Giugno",
  "Luglio",
  "Agosto",
  "Settembre",
  "Ottobre",
  "Novembre",
  "Dicembre",
];

const days = ["Domenica", "Lunedì", "Martedì", "Mercoledì", "Giovedì", "Venerdì", "Sabato"];
